import { SessionModeEnum } from '@protos/learning_management/lms.db_pb';
import {
  NavigateFunction,
  URLSearchParamsInit,
  createSearchParams,
} from 'react-router-dom';
import { RESOURCE_PAGE } from '../routeHandling/RoutesNomenclature';
import { ContentApprovalStatusEnum } from '@protos/content_management/content.db_pb';

interface ResourceParams {
  resourceId: string;
  lessonId?: string;
  lessonSessionId?: number;
  subjectId?: number;
  chapterId?: number;
  topicId?: number;
  resourceIndex?: number;
  classId?: number;
  section?: string;
  connectedClass?: string;
  connectedClassResourceSessionId?: string;
  sectionId?: number;
  approvalStatus?: ContentApprovalStatusEnum;
}

export type ResourceViewMode = 'add' | 'replace' | 'view' | undefined;

export const onResourceClick = (
  navigate: NavigateFunction,
  resourceParams: ResourceParams,
  sessionMode: SessionModeEnum,
  viewMode?: ResourceViewMode
) => {
  const {
    resourceId,
    lessonId,
    lessonSessionId,
    subjectId,
    chapterId,
    topicId,
    resourceIndex,
    classId,
    section,
    connectedClass,
    connectedClassResourceSessionId,
    sectionId,
    approvalStatus,
  } = resourceParams;
  const params: URLSearchParamsInit = {};
  if (connectedClass) {
    params.connectedClass = connectedClass;
  }
  if (resourceId) {
    params.resourceId = resourceId;
  }
  if (lessonId) {
    params.lessonId = lessonId;
  }
  if (typeof lessonSessionId == 'number') {
    params.lessonSessionId = lessonSessionId.toString();
  }
  if (typeof subjectId == 'number') {
    params.subjectId = subjectId.toString();
  }
  if (typeof chapterId == 'number') {
    params.chapterId = chapterId.toString();
  }
  if (typeof topicId == 'number') {
    params.topicId = topicId.toString();
  }
  if (typeof classId == 'number') {
    params.classId = classId.toString();
  }
  if (typeof sectionId == 'number') {
    params.sectionId = sectionId.toString();
  }
  if (viewMode) {
    params.viewMode = viewMode;
  }
  if (sessionMode) {
    params.sessionMode = sessionMode.toString();
  }
  if (section) {
    params.section = section;
  }
  if (typeof resourceIndex == 'number') {
    params.resourceIndex = resourceIndex.toString();
  }
  if (connectedClassResourceSessionId) {
    params.connectedClassResourceSessionId =
      connectedClassResourceSessionId.toString();
  }
  navigate(
    {
      pathname: RESOURCE_PAGE,
      search: resourceId ? `?${createSearchParams(params)}` : undefined,
    },
    {
      state: {
        approvalStatus: approvalStatus ? approvalStatus : undefined, // Pass state separately here
      },
    }
  );
};
